import { motion } from 'framer-motion';

export default function CTA() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="rounded-3xl overflow-hidden shadow-2xl"
        >
          <div className="relative w-full h-96">
            <img
              src="https://public.readdy.ai/ai/img_res/217e8fbd0b7ca1db2e39d2c7b0ece74b.jpg"
              alt="Consultation meeting"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="text-center mt-12"
        >
          <h2 className="text-4xl md:text-5xl font-serif mb-2">
            <span className="text-gray-900">Ready to start your</span>
          </h2>
          <h2 className="text-4xl md:text-5xl font-serif italic mb-2">
            <span className="text-gray-500">home buying journey?</span>
          </h2>
          <h2 className="text-4xl md:text-5xl font-serif font-bold">
            <span className="text-gray-900">Let's discuss your options</span>
          </h2>
          
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="mt-12 bg-navy text-white px-12 py-5 rounded-full text-lg font-semibold hover:bg-navy-light transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Schedule Free Consultation
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
}